import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('boundaryNameField');

    return {
        BOUNDARY_NAME_FIELD_LABEL: t('boundaryNameFieldLabel')
    };
};

export default useTranslation;
